<template>
	<el-form-item label="默认值">
		<el-input-number v-model="data.options.defaultValue" :max="data.options.max" :min="data.options.min" :step="data.options.step" />
	</el-form-item>

	<el-form-item label="最小值">
		<el-input-number v-model="data.options.min" />
	</el-form-item>

	<el-form-item label="最大值">
		<el-input-number v-model="data.options.max" />
	</el-form-item>

	<el-form-item label="步长">
		<el-input-number v-model="data.options.step" :min="0" />
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemSlider',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		return {
			data
		}
	}
})
</script>
